import { Controller } from "@hotwired/stimulus"
import { createAlert } from "../scripts/createAlert"

export default class extends Controller {
  async submit(event) {
    event.preventDefault()
    const form = event.target
    const button = form.querySelector('button[type="submit"]')

    if (button) {
      button.disabled = true
      button.innerText = "Downloading..."
    }

    try {
      const response = await fetch(form.action, {
        method: form.method.toUpperCase(),
        body: new FormData(form),
        headers: { "Accept": "application/zip" }
      })

      if (!response.ok) throw new Error("Network response was not ok")

      const blob = await response.blob()
      let filename = "download.zip"
      const disposition = response.headers.get("Content-Disposition")
      if (disposition) {
        const match = disposition.match(/filename[^;=\n]*=(['"]?)([^'"\n]*)\1/)
        if (match && match[2]) filename = decodeURIComponent(match[2])
      }

      const url = window.URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)

      if (window.bootstrap) {
        const modal = document.getElementById("download-all-media-modal")
        const instance = modal && bootstrap.Modal.getInstance(modal)
        if (instance) instance.hide()
      }

      createAlert("success", "Download completed!")
    } catch (error) {
      console.error(error)
      createAlert("danger", "Download failed. Please try again.")
    } finally {
      if (button) {
        button.disabled = false
        button.innerText = "Download"
      }
    }
  }
}
